import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import LoaderInfiniteLoop from 'widgets/loaderInfiniteLoop';
import { Card, Nav, Row, Tab, Col, Accordion, Alert, } from 'react-bootstrap';
import SimpleBar from 'simplebar-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IconAlert from 'components/common/IconAlert';

import { Axios } from 'helpers/axios';

import OneDPSBandeau from './oneDpsBandeau';
import OneDPSJalons from './oneDPSjalons';
import OneDPSParties from './oneDPSparties';
import OneDPSDocuments from './oneDPSdocuments';
import OneDPSPersonnel from './oneDPSpersonnel';
import OneDPSoneDemande from './oneDPSoneDemande';

const OneDPS = () => {
    let { idDPS } = useParams();

    const [isLoading, setIsLoading] = useState(true);
    const [pageNeedsRefresh, setPageNeedsRefresh] = useState(false);

    const [dps, setDps] = useState();
    const [parties, setParties] = useState();
    const [checkPoints, setCheckPoints] = useState();
    const [documents, setDocuments] = useState();
    const [documentsGroupe, setDocumentsGroupe] = useState();
    const [staffing, setStaffing] = useState([]);
    const [demandesDPS, setDemandesDPS] = useState([]);
    const [demandesDocs, setDemandesDocs] = useState([]);

    const navigate = useNavigate();
    const initPage = async () => {
        try {
            setIsLoading(true);

            const getOneDPS = await Axios.post('/authenticatedRoutes/dps/getOneDps',{
                idDPS: idDPS,
            });

            if(getOneDPS.data.rejected)
            {
                navigate('/errors/401');
            }else{
                if(!getOneDPS.data.dps)
                {navigate('/errors/500')}

                setDps(getOneDPS.data.dps);
                setParties(getOneDPS.data.parties);
                setCheckPoints(getOneDPS.data.checkPoints);
                setDocuments(getOneDPS.data.documents);
                setDocumentsGroupe(getOneDPS.data.documentsGroupe);
                setStaffing(getOneDPS.data.staffing);
                setDemandesDPS(getOneDPS.data.demandesDPS);
                setDemandesDocs(getOneDPS.data.demandesDocs);
            }

            setIsLoading(false);
        } catch (error) {
            console.error(error)
        }
    }

    useEffect(()=>{
        initPage();
    },[])

    useEffect(()=>{
        setPageNeedsRefresh(true);
    },[idDPS])

    useEffect(()=>{
        if(pageNeedsRefresh){initPage();}
        setPageNeedsRefresh(false);
    },[pageNeedsRefresh])

    return (<>
        {isLoading ?
            <LoaderInfiniteLoop />
        :
            <Row>
                <Col md={12}>
                    <OneDPSBandeau
                        dps={dps}
                        setPageNeedsRefresh={setPageNeedsRefresh}
                    />
                </Col>
                {dps.statutDPSannule ?
                    <Col md={12}>
                        <Alert variant='secondary'><center><b>Ce dispositif de secours a été annulé ou refusé. Il n'aura pas lieu.</b></center></Alert>
                    </Col>
                : null}
                {demandesDocs.length > 0 ?
                    <Col md={12}>
                        <IconAlert icon={'paperclip'} variant='warning'>
                            Nous avons besoin de documents vous concernant ! Cliquez sur le lien pour nous les envoyer !<br/>
                            {demandesDocs.map((demande, i)=>{return(
                                <Link key={i} to={'/requestDocOrga/'+demande.docRequestPublicCode}>{demande.textDemande};</Link>
                            )})}
                        </IconAlert>
                    </Col>
                : null}
                <Col md={4} className='mb-3'>
                    <OneDPSJalons
                        dps={dps}
                        checkPoints={checkPoints}
                    />
                </Col>
                <Col md={8}>
                    <Card>
                        <Tab.Container defaultActiveKey="demande">
                            <SimpleBar>
                                <Card.Header className="p-0 border-bottom">
                                    <Nav className="nav-tabs border-0 flex-nowrap tab-contact-details">
                                        <Nav.Item>
                                            <Nav.Link eventKey="demande" className="d-flex align-items-center py-3 px-x1 mb-0">
                                                <FontAwesomeIcon icon="clipboard-list" className="text-600 tab-icon"/>
                                                <h6 className="text-600 mb-0 ms-1">La demande</h6>
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="docs" className="d-flex align-items-center py-3 px-x1 mb-0">
                                                <FontAwesomeIcon icon="paperclip" className="text-600 tab-icon"/>
                                                <h6 className="text-600 mb-0 ms-1">Les documents</h6>
                                            </Nav.Link>
                                        </Nav.Item>
                                        {dps.clientAutoriseIS ?
                                            <Nav.Item>
                                                <Nav.Link eventKey="personnels" className="d-flex align-items-center py-3 px-x1 mb-0">
                                                    <FontAwesomeIcon icon="users" className="text-600 tab-icon"/>
                                                    <h6 className="text-600 mb-0 ms-1">Le personnel</h6>
                                                </Nav.Link>
                                            </Nav.Item>
                                        : null}
                                    </Nav>
                                </Card.Header>
                            </SimpleBar>
                            <Card.Body className="bg-light">
                                <Tab.Content>
                                    <Tab.Pane eventKey="demande">
                                        {parties.length > 0 ?
                                            <OneDPSParties
                                                parties={parties}
                                            />
                                        : null}
                                        {demandesDPS.length > 0 ?
                                            <Accordion className="mb-3" defaultActiveKey={0}>
                                                {demandesDPS.map((demande, i)=>{return(
                                                    <OneDPSoneDemande
                                                        key={i+1}
                                                        index={i+1}
                                                        demande={demande}
                                                    />
                                                )})}
                                            </Accordion>
                                        : null}
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="docs">
                                        <OneDPSDocuments
                                            idDPS={idDPS}
                                            documents={documents}
                                            documentsGroupe={documentsGroupe}
                                            demandesDPS={demandesDPS}
                                        />
                                    </Tab.Pane>
                                    {dps.clientAutoriseIS ?
                                        <Tab.Pane eventKey="personnels">
                                            <OneDPSPersonnel
                                                staffing={staffing}
                                            />
                                        </Tab.Pane>
                                    : null}
                                </Tab.Content>
                            </Card.Body>
                        </Tab.Container>
                    </Card>
                </Col>
            </Row>
        }
    </>);
};

export default OneDPS;